import { render } from "./MdMenu.vue?vue&type=template&id=bacde344"
import script from "./MdMenu.vue?vue&type=script&lang=js"
export * from "./MdMenu.vue?vue&type=script&lang=js"

import "./MdMenu.vue?vue&type=style&index=0&id=bacde344&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__